/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_UsageInputs */

const en_tut_sc_usage = /** @type {(inputs: Tut_Sc_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Analytics`)
};

const id_tut_sc_usage = /** @type {(inputs: Tut_Sc_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Analytics`)
};

/**
* | output |
* | --- |
* | "Jump to Analytics" |
*
* @param {Tut_Sc_UsageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_usage = /** @type {((inputs?: Tut_Sc_UsageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_UsageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_usage(inputs)
	return en_tut_sc_usage(inputs)
});